import {
  put,
  takeLatest,
  delay,
  debounce,
  takeEvery,
} from "@redux-saga/core/effects";
import { Notification } from "components/Notification/Noti";
import {
  createRecordAPI,
  loadDataAPI,
  massDeleteRecordAPI,
  updateRecordAPI,
} from "redux/api/objectsAPIs";
import {
  createQuotationItemAPI,
  createQuotationTemplateAPI,
  defaultQuotationTemplateAPI,
  deleteQuotationAPI,
  deleteQuotationItemAPI,
  deleteQuotationTemplateAPI,
  getListQuotationItemAPI,
  getListQuotationTemplateAPI,
  getQuotationHistoryAPI,
  renderTemplateAPI,
  toggleQuotationTemplateAPI,
  updatePositionQuotationItemAPI,
  updateQuotationItemAPI,
  updateQuotationTemplateAPI,
} from "redux/api/quotationAPI";
import { setShowLoadingScreen } from "redux/slices/global";
// import { setShowLoadingScreen } from "redux/slices/global";
import {
  getListQuotationTemplateSuccess,
  getListQuotationTemplate,
  createQuotationTemplate,
  toggleQuotationTemPlate,
  defaultQuotationTemplate,
  updateQuotationTemplate,
  deleteQuotationTemplate,
  getListRecordSuccess,
  getListRecord,
  createRecord,
  updateRecord,
  deleteQuotation,
  getListQuotationItem,
  getListQuotationItemSuccess,
  createQuotationItem,
  updateQuotationItem,
  deleteQuotationItem,
  updateIdClear,
  updatePositionQuotationItem,
  updateOptionEdit,
  getQuotationHistorySuccess,
  getQuotationHistory,
  renderTemplate,
  renderTemplateSuccess,
  updateIsDelete,
  updateIsCreate,
  updateIdReload,
  updateListIDCreate,
  getListSaleOrderItemSuccess,
} from "redux/slices/quotation";

export default function* quotationSaga() {
  yield takeLatest(getListQuotationTemplate.type, getListQuotationTemplateSaga);
  yield takeLatest(createQuotationTemplate.type, createQuotationTemplateSaga);
  yield takeLatest(toggleQuotationTemPlate.type, toggleQuotationTemPlateSaga);
  yield takeLatest(defaultQuotationTemplate.type, defaultQuotationTemPlateSaga);
  yield takeLatest(updateQuotationTemplate.type, updateQuotationTemPlateSaga);
  yield takeLatest(deleteQuotationTemplate.type, deleteQuotationTemPlateSaga);
  yield takeLatest(getListRecord.type, getListQuotationSaga);
  yield takeLatest(createRecord.type, createRecordSaga);
  yield takeLatest(updateRecord.type, updateRecordSaga);
  yield takeLatest(deleteQuotation.type, deleteQuotationSaga);
  yield debounce(1000, getListQuotationItem.type, getListQuotationItemSaga);
  yield debounce(1000, "RESET_DATA", resetDataSaga);
  yield takeEvery(createQuotationItem.type, createQuotationItemSaga);
  yield takeLatest(updateQuotationItem.type, updateQuotationItemSaga);
  yield takeLatest(deleteQuotationItem.type, deleteQuotationItemSaga);
  yield takeLatest(renderTemplate.type, renderTemplateSaga);
  yield takeLatest(
    updatePositionQuotationItem.type,
    updatePositionQuotationItemSaga
  );
  yield takeLatest(getQuotationHistory.type, getQuotationHistorySaga);
}

function* getListQuotationTemplateSaga(action) {
  try {
    const { data } = yield getListQuotationTemplateAPI(action.payload);
    yield put(getListQuotationTemplateSuccess(data.data));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* createQuotationTemplateSaga(action) {
  try {
    yield createQuotationTemplateAPI(action.payload);
    Notification("success", "Create template success");
    yield put(
      getListQuotationTemplate({ sale_order: action.payload.sale_order })
    );
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* toggleQuotationTemPlateSaga(action) {
  try {
    yield toggleQuotationTemplateAPI(action.payload);
    Notification("success", "Change status successfully!");
    yield put(
      getListQuotationTemplate({ sale_order: action.payload.sale_order })
    );
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* defaultQuotationTemPlateSaga(action) {
  try {
    yield defaultQuotationTemplateAPI(action.payload);
    Notification("success", "Set default template successfully!");
    yield put(
      getListQuotationTemplate({ sale_order: action.payload.sale_order })
    );
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* updateQuotationTemPlateSaga(action) {
  try {
    yield updateQuotationTemplateAPI(action.payload);
    Notification("success", "Update template success");
    yield put(
      getListQuotationTemplate({ sale_order: action.payload.sale_order })
    );
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* deleteQuotationTemPlateSaga(action) {
  try {
    yield deleteQuotationTemplateAPI(action.payload);
    Notification("success", "Delete template success");
    yield put(
      getListQuotationTemplate({ sale_order: action.payload.sale_order })
    );
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* getListQuotationSaga(action) {
  try {
    const { data } = yield loadDataAPI(action.payload);
    yield put(getListRecordSuccess(data.data));
    yield put(updateIsCreate(0));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* createRecordSaga(action) {
  try {
    const { data } = yield createRecordAPI(action.payload.data);
    Notification("success", "Create successfully!");
    yield put(getListRecord(action.payload.load));
    yield put(updateIsCreate(data?.data?._id));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* updateRecordSaga(action) {
  try {
    yield updateRecordAPI(action.payload.data);
    Notification("success", "Update successfully!");
    yield put(getListRecord(action.payload.load));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* deleteQuotationSaga(action) {
  try {
    if (action.payload.data.quotation_id) {
      yield deleteQuotationAPI(action.payload.data);
    } else {
      yield massDeleteRecordAPI(action.payload.data);
    }
    Notification("success", "Delete successfully!");
    yield put(getListRecord(action.payload.load));
    yield put(updateIsDelete(Math.random()));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* getListQuotationItemSaga(action) {
  try {
    const { data } = yield getListQuotationItemAPI(action.payload);
    if (action.payload.sale_order) {
      yield put(getListSaleOrderItemSuccess(data.data));
    } else {
      yield put(getListQuotationItemSuccess(data.data));
    }
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}
function* resetDataSaga() {
  try {
    yield put(updateIdClear(Math.random()));
    yield delay(2000);
    yield put(updateListIDCreate());
  } catch {}
}
const handleDataSubmit = (data) => {
  let tem = data.data;
  tem.sale_order_item_data = tem.quotation_item_data;
  delete tem.quotation_item_data;
  return { ...data, data: tem };
};

function* createQuotationItemSaga(action) {
  try {
    let dataSubmit = action.payload.data;
    if (action.payload.load?.sale_order) {
      dataSubmit = handleDataSubmit(action.payload.data);
    }
    const { data } = yield createQuotationItemAPI(dataSubmit);
    yield put(updateListIDCreate(data.data._id));
    yield put(getListQuotationItem(action.payload.load));
    yield put(
      updateIdReload(`${action.payload.load?.quotation_id}_${Math.random()}`)
    );
    yield put({ type: "RESET_DATA" });
  } catch (error) {
    yield put(getListQuotationItem(action.payload.load));
    Notification("error", error.response.data.error);
  } finally {
    yield put(setShowLoadingScreen(false));
  }
}

function* updateQuotationItemSaga(action) {
  try {
    let dataSubmit = action.payload.data;
    if (action.payload.load?.sale_order) {
      dataSubmit = handleDataSubmit(action.payload.data);
    }
    yield updateQuotationItemAPI(dataSubmit);
    Notification("success", "Update successfully!");
    yield put(updateOptionEdit(""));
    yield put(getListQuotationItem(action.payload.load));
    yield put(updateIdClear(Math.random()));
    yield put(
      updateIdReload(`${action.payload.load?.quotation_id}_${Math.random()}`)
    );
  } catch (error) {
    yield put(updateOptionEdit(""));
    Notification("error", error.response.data.error);
  }
}

function* updatePositionQuotationItemSaga(action) {
  try {
    yield updatePositionQuotationItemAPI(action.payload.data);
    Notification("success", "Update position item successfully!");
  } catch (error) {
    yield put(getListQuotationItem(action.payload.load));
    yield put(
      updateIdReload(`${action.payload.load?.quotation_id}_${Math.random()}`)
    );
    Notification("error", error.response.data.error);
  }
}

const handleDataDelete = (data) => {
  let tem = data.data;
  tem.sale_order_item_ids = tem.quotation_item_ids;
  delete tem.quotation_item_ids;
  return { ...data, data: tem };
};

function* deleteQuotationItemSaga(action) {
  try {
    let dataDelete = action.payload.data;
    if (action.payload.load?.sale_order) {
      dataDelete = handleDataDelete(action.payload.data);
    }
    yield deleteQuotationItemAPI(dataDelete);
    Notification("success", "Delete successfully!");
    yield put(getListQuotationItem(action.payload.load));
    yield put(
      updateIdReload(`${action.payload.load.quotation_id}_${Math.random()}`)
    );
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* getQuotationHistorySaga(action) {
  try {
    const { data } = yield getQuotationHistoryAPI(action.payload);
    yield put(getQuotationHistorySuccess(data.data));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* renderTemplateSaga(action) {
  try {
    const { data } = yield renderTemplateAPI(action.payload);
    yield put(renderTemplateSuccess(data.data?.content));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}
